import { render, staticRenderFns } from "./PayerLoyerForm.vue?vue&type=template&id=02c2b99c"
import script from "./PayerLoyerForm.vue?vue&type=script&lang=js"
export * from "./PayerLoyerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports